<div class="message">
  <div *ngFor="let message of messages; last as last" class="rounded-lg p-4 text-sm normal-case flex flex-col gap-1"
    [class.mb-4]="!last"
    [ngClass]="classesType[message.type]">

    <div *ngIf="message.title" class="font-bold">{{message.title}}</div>
    <div role="alert" [innerHtml]="message.message"></div>
  </div>
</div>
